import { TRAVEL_OPTIONS_CONST } from '../actionConstants';
import { setApiLoading, setApiError } from './shortlistNShareActions';
import { getccbAxiosConfig } from '../../apisSetup/ccbConfig';

const PAGE_LOAD = 'PAGE_LOAD';
import {
	saveServerLogs, getSearchParams
} from 'UtilityComponents/Util';
import {
	APPLICATION_CONSTANTS,
	PATHS
} from 'AppConstants';

const axiosApiCaller = getccbAxiosConfig(true, {
	'os': APPLICATION_CONSTANTS.DEVICE_TYPE
}, false);

const appendWishId = (url, wishId) => {
	const iD = wishId ? wishId : getSearchParams().wishlistId;
	return `${url}?wishlistId=${iD}`;
};

export const removeWishlistProduct = (wishlistId, idData, grpId, lob)=> async (dispatch) => {
	let resp = null;
	try {
		dispatch(setApiLoading(PAGE_LOAD));
		const data = {
			productIdList: idData
		};
		resp = await axiosApiCaller.post(appendWishId(PATHS.REMOVE_PRODUCT, wishlistId), data);
		dispatch(setApiLoading(false));
		if (resp.data && resp.data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			dispatch({
				type: SHORTLIST_OPTIONS_CONST.UPDATE_GRPIDS_DATA,
				payload: { idData, grpId, lob }
			});
		}
	} catch (e) {
		dispatch(setApiError());
		saveServerLogs(e.stack, 'error', '');
	} finally {
		dispatch(setApiLoading(false));
	}
};

export const travelRequests = () => async (dispatch) => {
	let resp = null;
	try {
		resp = await axiosApiCaller.get(`${PATHS.TRAVEL_REQUESTS}?provideRequisitionDetails=true` );
		const { data } = resp;
		if (data.responseCode === APPLICATION_CONSTANTS.SUCCESS_RESPONSE_CODE) {
			dispatch({
				type: TRAVEL_OPTIONS_CONST.SET_TRAVEL_REQUESTS,
				payload: data
			});
		}
	} catch (e) {
		saveServerLogs(e.stack, 'error', '');
	}
};

export const filterResults = (searchValue) => (dispatch) => {
	dispatch({
		type: TRAVEL_OPTIONS_CONST.FILTER_REQUISITION_REQUESTS,
		payload: { searchValue }
	});
};
